import type { LogoBarProps as Props } from './types';
import { cls } from '@/utils/cls';
import style from './LogoBar.module.scss';
export default function LogoBar({
  extendStyles,
  heading,
  logos
}: Props) {
  const _className = cls(style.root, extendStyles);
  const hasLogos = !!logos && logos.length > 0;
  return <aside className={_className} data-sentry-component="LogoBar" data-sentry-source-file="LogoBar.tsx">
			<div data-grid>
				<div className={style.content}>
					{heading && <h3 className={style.copy}>{heading}</h3>}
					<div className={style.logos}>
						{hasLogos && logos.map(({
            logo,
            link
          }) => {
            if (!logo || !logo.value) {
              return null;
            }
            return link ? <a target="_blank" rel="noopener noreferrer" href={link} key={`logo-image-${logo.value?.data.name}`}>
										<img className={style.logo} src={logo.value?.data.image} alt={logo.value?.data.name} width="120" height="40" />
									</a> : <img key={`logo-image-${logo.value?.data.name}`} className={style.logo} src={logo.value?.data.image} alt={logo.value?.data.name} />;
          })}
					</div>
				</div>
			</div>
		</aside>;
}